/**
 * @generated SignedSource<<4ddee8c9bba00a546f3452ca6d33f2da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FileInfoScreenUpdateNameMutation$variables = {
  id: string;
  name: string;
};
export type FileInfoScreenUpdateNameMutation$data = {
  readonly file: {
    readonly update: {
      readonly id: string;
      readonly name: string | null;
    };
  };
};
export type FileInfoScreenUpdateNameMutation = {
  response: FileInfoScreenUpdateNameMutation$data;
  variables: FileInfoScreenUpdateNameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "FileMutation",
    "kind": "LinkedField",
    "name": "file",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "setName",
                "variableName": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileInfoScreenUpdateNameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileInfoScreenUpdateNameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "399876d108d2c3ce62907a4dbc3edc50",
    "id": null,
    "metadata": {},
    "name": "FileInfoScreenUpdateNameMutation",
    "operationKind": "mutation",
    "text": "mutation FileInfoScreenUpdateNameMutation(\n  $id: ID!\n  $name: String!\n) {\n  file(id: $id) {\n    update(input: {setName: $name}) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "221f144ac84fcb07fe3ec67cf235fe85";

export default node;
